import Hero from "./home/Hero"
import Content from "./404/content"
import Footer from "./layout/Footer"
import Media from "./partner/Media"

const notFound = () => {
    return (
        <div>
            <Hero/>
            <Content/>
            <Media/>
            <Footer/>
        </div>
    )
}

export default notFound